import { testMsg } from "../../test-apis";
import { isTestCompany } from "../../utils/auth";
import http from "../../utils/http";
import { toast } from "../../utils/toast";

// 금융 로그인 타입 조회
export const getFinancesType = (orgCd) => {
  return new Promise((resolve, reject) => {
    http
      .get("/finances", {
        params: {
          orgCd,
        },
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 인증
export const postFinancesAuth = (body) => {
  return new Promise((resolve, reject) => {
    if (isTestCompany()) {
      testMsg();
      reject();
      return;
    }
    http
      .post("/finances/auth", body)
      .then((res) => {
        toast.success("인증되었습니다.");
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

//금융정보 수집 인증 데이터 조회
export const getFinancesAccounts = (orgCd) => {
  return new Promise((resolve, reject) => {
    http
      .get("/finances/accounts", {
        params: {
          orgCd,
        },
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 인증정보 변경
export const modifyFinancesAccounts = (financeAccountIdx, body) => {
  return new Promise((resolve, reject) => {
    if (isTestCompany()) {
      testMsg();
      reject();
      return;
    }
    http
      .put(`/finances/accounts/${financeAccountIdx}`, body)
      .then((res) => {
        toast.success("인증 정보를 변경했습니다.");
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 금융정보 수집 인증정보 제거
export const deleteFinancesAccounts = (financeAccountIdx,) => {
  return new Promise((resolve, reject) => {
    if (isTestCompany()) {
      testMsg();
      reject();
      return;
    }
    http
      .delete(`/finances/accounts/${financeAccountIdx}`)
      .then((res) => {
        toast.success("인증 정보를 삭제했습니다.");
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 금융정보(은행계좌/카드) 별칭 수정
export const modifyBankNickName = (financeScrapingIdx, body) => {
  return new Promise((resolve, reject) => {
    if (isTestCompany()) {
      testMsg();
      reject();
      return;
    }
    http
      .put(`/finances/nickname/${financeScrapingIdx}`, body)
      .then((res) => {
        toast.success("별칭을 설정했습니다.");
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 금융정보 수집 스크래핑 수정
export const modifyFinancesScraping = (financeScrapingIdx, body) => {
  return new Promise((resolve, reject) => {
    if (isTestCompany()) {
      testMsg();
      reject();
      return;
    }
    http
      .put(`/finances/scraping/${financeScrapingIdx}`, body)
      .then((res) => {
        toast.success("스크래핑 정보를 수정했습니다.");
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 금융정보 신용카드 사용 직원 등록
export const postMappingFinancesCardsAndEmployees = (financeScrapingIdx, body) => {
  return new Promise((resolve, reject) => {
    if (isTestCompany()) {
      testMsg();
      reject();
      return;
    }
    http
      .post(`/finances/cards/${financeScrapingIdx}/employees`, body)
      .then((res) => {
        toast.success("해당 신용카드에 직원을 등록하였습니다.");
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 금융정보 신용카드 사용 직원 삭제
export const deleteMappingFinancesCardsAndEmployees = (financeScrapingIdx, body) => {
  return new Promise((resolve, reject) => {
    if (isTestCompany()) {
      testMsg();
      reject();
      return;
    }
    http
      .delete(`/finances/cards/${financeScrapingIdx}/employees`, {
        data: {
          employeeIdxList: body
        }
      })
      .then((res) => {
        toast.success("해당 신용카드에 직원을 삭제하였습니다.");
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 스크래핑 내역 조회
export const getFinanacesScrapingHistoryList = (financeScrapingIdx, body = {}) => {
  if (!body.order) {
    body.order = [
      { idx: 'desc' }
    ];
  }
  return new Promise((resolve, reject) => {
    http
      .post(`/finances/scraping/${financeScrapingIdx}/histories/list`, body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const getFinanacesScrapingHistoryAllList = (body = {}) => {
  if (!body.order) {
    body.order = [
      { idx: 'desc' }
    ];
  }
  return new Promise((resolve, reject) => {
    http
      .post(`/finances/scraping/histories/all/list`, body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 수동 스크래핑
export const scrapingFinanaces = (financeScrapingIdx, body) => {
  return new Promise((resolve, reject) => {
    if (isTestCompany()) {
      testMsg();
      reject();
      return;
    }
    http
      .post(`/finances/scraping/${financeScrapingIdx}/scraping`, body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 전체 수동스크래핑 (3개월 제한)
// detailType : card, bk
export const scrapingFinanacesAll = (body) => {
  return new Promise((resolve, reject) => {
    if (isTestCompany()) {
      testMsg();
      reject();
      return;
    }
    http
      .post('/finances/scraping/all', body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
